"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _makeStyle = _interopRequireDefault(require("../../../utils/makeStyle"));
var useStyle = (0, _makeStyle.default)('GridDemo', function (token) {
  return {
    '.previewer-grid-demo': (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(token.rootCls, "-row"), {
      marginBottom: 16
    }), "".concat(token.rootCls, "-row > div:not(.gutter-row)"), {
      padding: '16px 0',
      background: '#0092ff',
      color: '#fff',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:nth-child(2n + 1)': {
        background: 'rgba(0,146,255,.75)'
      }
    })
  };
});
var Demo = function Demo() {
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    hashId = _useStyle2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('previewer-grid-demo', hashId)
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, "col")), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, "col-12"), " ", /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, "col-12")), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 8
  }, "col-8"), " ", /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 8
  }, "col-8"), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 8
  }, "col-8")), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, "col-6"), " ", /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, "col-6"), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, "col-6"), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, "col-6")));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  key: 'default'
};
var _default = exports.default = componentDemo;